import React from 'react';
import styles from './FocusLearningPaths.module.scss';
import User from 'infrastructure/User';
import icon_Focus_LP from 'assets/learningPaths/icon-Focus-LP.svg';
import { format, parseISO } from 'date-fns';
import Organization from 'infrastructure/Organization';
import UserAvatars from '../LearningPathDetails/UserAvatars';
const LP_STATUS = {
  1: 'Not Started',
  2: 'In Progress',
  3: 'Completed',
};
const FocusLearningPathHeader = ({ learningPath = {} }) => {
  const {
    title = '',
    description = '',
    created_by = {},
    total_contents = 0,
    updated_at,
    deadline,
    users = [],
    status,
  } = learningPath;

  const isAdminView = Organization.isAdmin();
  const isRepView = Organization.isRep();
  return (
    <div className={styles.salesCard}>
      <div className={styles.headerContainer}>
        <div>
          <div className={styles.header}>
            <img src={icon_Focus_LP} alt="icon" className={styles.icon} />
            <div className={styles.title}>{title}</div>
          </div>
        </div>
        <div className={styles.tableHeader}>
          <table className={styles.metaTable}>
            <tbody>
              <tr>
                <td className={styles.label}>Author</td>
                <td className={styles.label}>Skill Sets</td>
                <td className={styles.label}>Updated on</td>
                <td className={styles.label}>Due</td>
                {isRepView && <td className={styles.label}>State</td>}
              </tr>
              <tr>
                <td className={styles.labelContent}>{User.getUserName(created_by)}</td>
                <td className={styles.labelContent}>{total_contents}</td>
                <td className={styles.labelContent}>
                  {format(parseISO(updated_at), 'MMM do, yyyy')}
                </td>
                <td className={styles.labelContent}>
                  {format(parseISO(deadline), 'MMM do, yyyy')}
                </td>
                {isRepView && <td className={styles.labelContent}>{LP_STATUS[status]}</td>}
              </tr>
            </tbody>
          </table>
          {!isRepView && <UserAvatars users={users} />}
        </div>
      </div>
      <p className={styles.FocusDescription}>{description}</p>
    </div>
  );
};

export default FocusLearningPathHeader;
